import { z } from "zod";
export const googleCalendarStatusSchema = z.object({
    available: z.boolean(),
    state: z.enum(["not_connected", "connected", "revoked", "failed"]),
    email: z.string().nullable(),
});
//# sourceMappingURL=google.js.map